import { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FieldsFilter, Grid, InputSearch } from 'src/components/UI'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { invoiceActions } from 'src/ducks/actions'
import { getClientData } from 'src/ducks/client/selectors'
import { getInvoicesForClient } from 'src/ducks/invoice/selectors'
import { formatTimestamp } from 'src/helpers'
import { InvoiceType } from '~api/types'
import headers from './headers'

const Invoices: FC = () => {
    const [searchFilter, setSearchFilter] = useState('')
    const [tableHeaders, setTableHeaders] = useState(headers)
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()
    const userData = useSelector(getClientData())
    const clientId = userData?.id as string

    const onTableFilterChange = (index: number): void => {
        setTableHeaders(tableHeaders.map((item, indx) => {
            if (indx === index) {
                return { ...item, hide: !item.hide }
            }
            return item
        }))
    }

    // For now, using empty data
    const invoicesData = useSelector(getInvoicesForClient()) || []

    // Filter invoices based on search
    const filteredInvoices = invoicesData.filter((invoice: any) => {
        if (!searchFilter) return true
        const searchLower = searchFilter.toLowerCase()
        return (
            invoice.id?.toLowerCase().includes(searchLower) ||
            invoice.status?.toLowerCase().includes(searchLower)
        )
    })

    // Transform data to match table headers
    const tableData = filteredInvoices.map((invoice: any) => ({
        ...invoice,
        amountDue: invoice.amountDue ? `$${invoice.amountDue.toFixed(2)}` : '$0.00',
        amountPaid: invoice.amountPaid ? `$${invoice.amountPaid.toFixed(2)}` : '$0.00',
        dueDate: invoice.dueDate ? formatTimestamp(invoice.dueDate, 'MM/DD/YYYY') : '-',
        status: invoice.status || '-',
    }))

    const fetchInvoices = useCallback(() => {
        dispatch(invoiceActions.fetchInvoicesForClient(clientId, (succ: boolean, invoices: InvoiceType[]) => {
            setLoading(false)
        }))
    }, [clientId, dispatch])

    useEffect(() => {
        fetchInvoices()
    }, [fetchInvoices])

    return (
        <Grid container direction="column" flex={1} spacing={2}>
            <Grid item container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <InputSearch
                        placeholder='Search...'
                        onChange={setSearchFilter}
                        value={searchFilter}
                    />
                </Grid>
                <Grid item>
                    <FieldsFilter options={tableHeaders} handleChange={onTableFilterChange} />
                </Grid>
            </Grid>
            <Grid item>
                <Table
                    headers={tableHeaders}
                    loading={loading}
                >
                    {tableData}
                </Table>
            </Grid>
        </Grid>
    )
}

export default Invoices